module.exports = __webpack_public_path__ + "img/img_whyIsUseful_pattern1.a03499c4.png";